export default {
  WORKING_HOURS: [[9, 18]],
  VAPID_PUBLIC_KEY:
    "BH_VGM8rwJtryZtIYeXx-5ea9xTm6f21rNB5ubNWcl9V6yirLv57VvSHISEr44Kerz4RDgYzjBK94u7-m4WixG8",
}
